import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "../HeightPin";
import ScrollSection from "../ScrollSection";
import GemDiscover from "../elements/GemDiscover";
import MoodBoard from "../MoodBoard"
import ImageCirclePack from "../charts/ImageCirclePack";
import TreeMap from "../charts/TreeMap";
import CardFlip from "../elements/CardFlip";
import DidYouKnow from "../elements/DidYouKnow";
import FormElement from "../elements/FormElement";
import SectionTop from "./SectionTop";
import Results from "../elements/Results";
import {getAltText, getSectionImage, getInfoClass, getImageInfoStyle} from "../../assets/settings";

function Academics(props) {
    const {store, state, color, index, downhill} = props;
    const {circlePackStore} = store;

    const group = 'AC';
    const activeKey = store.activeSection(group) || 'AC_2';



    const sectionY = 0.35;

    return (
        <div className={'Section'}>
            <SectionTop group={group} downhill={downhill}>
                <h4>
                    How does the physical environment support the university’s academic and research mission?
                </h4>
                <p>
                    The Long Range Development Plan and Campus Master Plan take an in-depth look at academic and
                    research space needs to inform where new development should go on campus.
                </p>
            </SectionTop>
            <HeightPin store={store} state={state} scrollChild={<div className={'left-scroll'}>
                <div className={'spacer'} style={{height: 150}}/>

                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`AC_2`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'AC_2')}>
                        <h4>More than 60% of existing campus space is dedicated to academic uses.</h4>
                        <p>
                            This pie chart shows the distribution of overall space types within the existing campus.
                        </p>
                        <p>
                          Research, office, and conference space comprise the majority of academic space on-campus. Although it is highly used, instructional space comprises a small proportion of overall existing space, which is similar to other research-intensive universities.
                        </p>
                        <p>
                            Though there may be programmatic need for new space, the campus also has a significant backlog of deferred maintenance that impacts user experiences.
                        </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`AC_3`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'AC_3')}>
                        <p>
                            In general, rooms with 100 seats or more are the most well used. Many of these classrooms are in Dwinelle Hall, which also has the greatest number of classrooms of any campus building.
                        </p>
                        <DidYouKnow store={store} color={color}>
                            <p>
                              Did you know that the smallest classroom on campus has 13 seats, in Barrows Hall? The largest is in Wheeler Hall, with 744 seats.
                            </p>
                        </DidYouKnow>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`AC_4`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'AC_4')}>
                        <h4>
                            What types of additional academic life spaces are needed to improve the campus experience
                            and help build community?
                        </h4>
                        <p>
                            The 2019 LRDP & Campus Master Plan survey asked the campus community to select which academic spaces they wanted to see added to the campus. Across all respondents, individual study spaces were selected as the most pressing need, followed by collaboration spaces/group study spaces and improved classrooms.
                        </p>
                        <p>
                            The shortage of study space impacts social spaces, which are frequently used as study spaces. See the Long Range Development Plan and Campus Master Plan websites for more information about the survey results.
                        </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`AC_5`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'AC_5')}>
                        <h4>
                            How much additional space is needed to support academic life?
                        </h4>
                        <p>
                            Across all academic, research, and administrative space types (e.g. classrooms, labs, office) there is a deficit -- not enough space to meet demand.
                        </p>
                        <p>
                            The total estimated academic space need is an additional 3.0 million net new GSF of academic, research, and support space in the future.
                        </p>
                    </div>
                </ScrollSection>

                <div className={'spacer'} style={{height: '50vh'}}/>
            </div>}
                       pinChild={<div className={'sticky-image-right'}>
                           <div className={'frame'}>
                              {getAltText(activeKey).title && <h4 style={{'backgroundColor': color + '80'}}>{getAltText(activeKey).title}</h4>}
                               <img width={'100%'} src={getSectionImage(group, activeKey)} alt={getAltText(activeKey).alt}/>
                           </div>
                       </div>}
            />
            <div className={'interactive'}>
                <CardFlip color={color} index={index} store={store}
                          frontFace={<FormElement store={store} id={group}/>}
                          backFace={<Fragment>
                              <Results store={store} id={group} />
                          </Fragment>}/>
            </div>
        </div>
    );
}

export default observer(Academics);
